import { observable } from 'mobx'
import Api from '@api/xi_feng/newCustomer'

class Store {
  @observable followModalVisible = false // 不再跟进，再次跟进 modal

  setStoreData = (params = {}) => {
    Object.keys(params).forEach(key => {
      this[key] = params[key]
    })
  }

  constructor(detailStore) {
    this.detailStore = detailStore
  }

  setFollowStatus = async params => {
    const { success } = await Api.setFollowStatus({
      merchant_customer_id: this.detailStore.id,
      ...params
    })

    if (success) {
      this.setStoreData({ followModalVisible: false })
      this.detailStore.refresh()
    }
  }
}

export default Store
